if (!customElements.get('search-filter')) {
  class SearchFilter extends HTMLElement {
    constructor () {
      super()
      this.init()
    }

    init () {
      // Clean up the previous instance, if any
      this.removeEventListener('input', this.filterList)

      this.input = this.querySelector('input')
      if (this.input) {
        this.input.addEventListener('input', this.filterList.bind(this))
      }
    }

    filterList () {
      const searchTerm = this.input.value.toLowerCase()
      const colorList = this.nextElementSibling.querySelector('.clc-ProductGridFacet_List')
      const showMoreButton = colorList.querySelector('.clc-ProductGridFacet_ShowMore')

      if (colorList && colorList.classList.contains('clc-ProductGridFacet_List')) {
        const colorItems = colorList.querySelectorAll('.clc-ProductGridFacet_Item')

        if (searchTerm.length > 0) {
          showMoreButton.style.display = 'none'

          colorItems.forEach(item => {
            const colorText = item.querySelector('.clc-ProductGridFacet_CheckboxText')?.textContent.toLowerCase() || ''
            if (colorText.includes(searchTerm)) {
              item.classList.remove('clc-ProductGridFacet_Item-hidden')
            } else {
              item.classList.add('clc-ProductGridFacet_Item-hidden')
            }
          })
        } else {
          showMoreButton.style.display = 'block'
          showMoreButton.dataset.state = 'more'
          showMoreButton.textContent = showMoreButton.dataset.textMore

          colorItems.forEach(item => {
            item.classList.remove('clc-ProductGridFacet_Item-hidden')

            const defaultHiddenItems = colorList.querySelectorAll('[data-default-hidden="true"]')

            defaultHiddenItems.forEach(item => {
              item.classList.add('clc-ProductGridFacet_Item-hidden')
            })
          })
        }
      }
    }

    connectedCallback () {
      this.init()
    }

    disconnectedCallback () {
      this.removeEventListener('input', this.filterList)
    }
  }

  customElements.define('search-filter', SearchFilter)
}
